/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetUploadIcon16Regular = forwardRef('NetUploadIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.998 5.56a.75.75 0 1 1-.996-1.12l3.503-3.115a2.25 2.25 0 0 1 2.99 0l3.503 3.114a.75.75 0 0 1-.996 1.122L8.75 2.67v7.579a.75.75 0 0 1-1.5 0V2.67L3.998 5.56Z" }),
        React.createElement("path", { d: "M1.75 13a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75Z" })));
});
